import React from 'react';
import loadable from '@loadable/component';

import query from './query.graphql';
import { Props } from './editorial-content-listing';

const EditorialContentListing = loadable(() =>
  import(/* webpackChunkName: "article" */ './editorial-content-listing')
);

const EditorialContentListingPage = (props: Props) => (
  <EditorialContentListing {...props} />
);

EditorialContentListingPage.graphQL = query;

type EditorialContentListingVariables = {
  offset: string | number;
};

EditorialContentListingPage.variables = ({
  offset,
}: EditorialContentListingVariables) => {
  const pageSize = 20;
  const parsedOffset =
    typeof offset === 'string' ? parseInt(offset, 10) : offset;

  return {
    page:
      parsedOffset === null || parsedOffset === undefined
        ? 1
        : parsedOffset / pageSize + 1,
    pageSize,
  };
};

export default EditorialContentListingPage;
